import JQueryView, { on } from '../../../common/views/jqueryView';

export default class BundleView extends JQueryView {
  constructor() {
    super('body');

    $(window).scroll(function () {
      const scrollTop = $(window).scrollTop();
      if (scrollTop != null && scrollTop > 0) {
        $('.g-header').addClass('is-fixed');
      } else {
        $('.g-header').removeClass('is-fixed');
      }
    });
  }

  @on({ event: 'click', selector: '#menu-button' })
  onClickMenuButton() {
    $('#dropdown-menu').toggleClass('hidden');
    $('#overlay').toggleClass('hidden');
    $('body').toggleClass('is-fixed');
  }

  @on({ event: 'click', selector: '#overlay' })
  onClickOverLay() {
    $('#dropdown-menu').toggleClass('hidden');
    $('#overlay').toggleClass('hidden');
    $('body').removeClass('is-fixed');
  }

  @on({ event: 'click', selector: '#g-notification-dissmis' })
  onClickNotificationDissmis() {
    return ($('#g-notification-dissmis').parent().hide(), !1);
  }
}
